import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "align-right",
  "use": "align-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"align-right\"><g class=\"is-icon-target\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m14 0h-14\" transform=\"translate(7 10)\" /><path d=\"m18 0h-18\" transform=\"translate(3 6)\" /><path d=\"m18 0h-18\" transform=\"translate(3 14)\" /><path d=\"m14 0h-14\" transform=\"translate(7 18)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol